import { Button, TextInput } from 'carbon-components-react';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  handleChangeValues: PropTypes.func,
  isValidHeaders: PropTypes.func,
  defaultValues: PropTypes.array
};

type Props = PropTypes.InferProps<typeof propTypes> & any;

interface inputObj {
  name: any;
  idx: number;
  value: any;
}
const AddCustomHeadersTextFields: React.FC<Props> = (props: Props) => {
  const { handleChangeValues, isValidHeaders, defaultValues } = props;
  const [fields, setFields] = useState([{ name: '', value: '' }]);
  const [lastElementEmpty, setLastElementEmpty] = useState<boolean>(true);

  const onBlurHandler = (val: any) => {
    const isEmptyFields = val === '';
    isValidHeaders(isEmptyFields);
    setLastElementEmpty(isEmptyFields);
  };

  const handleChange = (obj: inputObj) => {
    const { idx, value } = obj;
    const values = [...fields];

    if (obj.name === 'key') values[idx].name = value;
    if (obj.name === 'value') values[idx].value = value;
    handleChangeValues({ customHeaders: values });
    setFields(values);
  };

  const handleAdd = () => {
    const values = [...fields];
    values.push({ name: '', value: '' });
    setFields(values);
    setLastElementEmpty(true);
  };
  useEffect(() => {
    if (defaultValues.length > 0) {
      if (Array.isArray(defaultValues[0])) {
        setFields(defaultValues[0]);
      } else {
        setFields(defaultValues);
      }
    }
  }, [defaultValues]);

  return (
    <>
      {fields.map((field, idx) => {
        return (
          <div
            className="form-section--item dynamic-field"
            key={`${field}-${idx}`}
          >
            <TextInput
              id={`key-${idx}`}
              name={`key-${idx}`}
              labelText={idx === 0 ? `Custom HTTP headers (optional)` : ``}
              placeholder="KEY (NAME)"
              defaultValue={field['name']}
              onBlur={(e) => onBlurHandler(e.target.value)}
              onChange={(e) =>
                handleChange({ name: 'key', idx, value: e.target.value })
              }
            />
            <TextInput
              id={`value-${idx}`}
              name={`value-${idx}`}
              labelText=""
              placeholder="VALUE"
              defaultValue={field['value']}
              onBlur={(e) => onBlurHandler(e.target.value)}
              onChange={(e) =>
                handleChange({ name: 'value', idx, value: e.target.value })
              }
            />
          </div>
        );
      })}
      <Button
        className="custom-http-header--btn"
        kind="ghost"
        disabled={lastElementEmpty}
        onClick={() => handleAdd()}
      >
        + custom HTTP header
      </Button>
    </>
  );
};

AddCustomHeadersTextFields.defaultProps = {
  handleChangeValues: () => {},
  isValidHeaders: () => {},
  defaultValues: []
};
export default AddCustomHeadersTextFields;
